import { Uploader } from "./upload_common";
import { S3Upload } from "./s3";

class NormalUploader extends Uploader {

    constructor(root) {
        super(root)

        this.video = this.root.querySelector('.video')
        this.videoUrl = null
        this.videoTimeout = null

        this.frames = []
        this.stills = []
        this.gallery = []
        this.method = ""

        this.typeCount = { video: 0, image: 0 }

        let that = this

        this.video.onchange = () => {
            that.validateVideo()
            that.markSectionUsed('video')
        }

        this.video.onkeyup = () => {
            that.validateVideo()
            that.markSectionUsed('video')
        }

        this.initializeCollapsibleSections()
    }

    validateRow(target, files) {
        const container = target.closest('.uploader-container')
        const status = container.querySelector('.upload-status')
        const row = parseInt(container.getAttribute('data-row'))


        if (row === 1) {
            for (let file of files) {
                this.frames.push(file);
                if (this.isVideo(file)) {
                    this.typeCount.video++;
                } else if (this.isImage(file)) {
                    this.typeCount.image++;
                } else {
                    this.frames = [];
                    this.statusError(status, "Please upload only videos or images.")
                    return;
                }
            }

            this.method = "";

            if (this.typeCount.video === 1 && this.typeCount.image === 0) {
                this.method = "videos";
                this.statusSuccess(status, '1 video selected.');
                this.enableSubmit();
                this.markSectionUsed('frames')
            } else if (this.typeCount.video === 0 && this.typeCount.image >= 4 && this.typeCount.image <= 360) {
                this.method = "frames"
                this.statusSuccess(status, `${this.frames.length} images selected.`)
                this.enableSubmit();
                this.markSectionUsed('frames')
            } else {
                this.frames = [];
                this.typeCount = { video: 0, image: 0 };
                const errorMessage = 'Please upload 4..360 images (.jpg, .jpeg, .png) or one video (.mpg, .mpeg, .mp4, .webm, .avi, .mov)';
                this.statusError(status, errorMessage);
                this.disableSubmit();
            }
        }

        if (row === 13) {
            for (let file of files) {
                if (this.isImage(file)) {
                    if (this.stills.length < 24) {
                        this.stills.push(file);
                    }
                } else {
                    this.stills = [];
                    this.statusError(status, "Please upload only still images.")
                    return;
                }
            }

            this.statusSuccess(status, `${this.stills.length} files selected`)
            this.markSectionUsed('stills')
        }

        if (row === 14) {
            for (let file of files) {
                if (this.isImage(file)) {
                    this.gallery.push(file);
                } else {
                    this.gallery = [];
                    this.statusError(status, "Please upload only gallery images.")
                    return;
                }
            }

            this.statusSuccess(status, `${this.gallery.length} files selected`)
            this.markSectionUsed('gallery')
        }
    }

    reset() {
        this.typeCount = { video: 0, image: 0 };
        this.frames = [];
        this.stills = [];
        this.gallery = [];

        for (let status of this.root.querySelectorAll('.upload-status')) {
            status.innerHTML = '';
        }

        this.disableSubmit();
    }

    initializeCollapsibleSections() {
        const sections = this.root.querySelectorAll('.upload-section')
        if (!sections.length) return

        const storageKey = 'normal_upload_section_usage_v1'
        let usage = {}

        try {
            const raw = window.localStorage.getItem(storageKey)
            if (raw) {
                usage = JSON.parse(raw) || {}
            }
        } catch (e) {
            usage = {}
        }

        // If we have any usage, start with all sections collapsed,
        // then expand only those that have been used before.
        const hasUsage = Object.keys(usage).length > 0

        sections.forEach(section => {
            const key = section.getAttribute('data-upload-section-key')
            const toggle = section.querySelector('.upload-section-toggle')
            const isUsed = hasUsage && usage[key]

            if (hasUsage && !isUsed) {
                section.classList.add('is-collapsed')
                if (toggle) {
                    toggle.setAttribute('aria-expanded', 'false')
                    toggle.textContent = 'Show'
                }
            } else {
                section.classList.remove('is-collapsed')
                if (toggle) {
                    toggle.setAttribute('aria-expanded', 'true')
                    toggle.textContent = 'Hide'
                }
            }

            if (toggle) {
                toggle.addEventListener('click', (event) => {
                    event.preventDefault()
                    const collapsed = section.classList.toggle('is-collapsed')
                    const expanded = !collapsed
                    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false')
                    toggle.textContent = expanded ? 'Hide' : 'Show'
                })
            }
        })

        this._sectionUsageKey = storageKey
    }

    markSectionUsed(sectionKey) {
        if (!sectionKey || !this._sectionUsageKey) return

        let usage = {}
        try {
            const raw = window.localStorage.getItem(this._sectionUsageKey)
            if (raw) {
                usage = JSON.parse(raw) || {}
            }
        } catch (e) {
            usage = {}
        }

        const now = Date.now()
        const existing = usage[sectionKey] || { count: 0, lastUsedAt: 0 }
        usage[sectionKey] = {
            count: existing.count + 1,
            lastUsedAt: now
        }

        try {
            window.localStorage.setItem(this._sectionUsageKey, JSON.stringify(usage))
        } catch (e) {
            // Ignore storage errors (e.g., private mode)
        }
    }

    enableSubmit() {
        this.submitButton.removeAttribute('disabled');
    }

    disableSubmit() {
        this.submitButton.setAttribute('disabled', 'disabled');
    }


    doSubmit() {
        if (this.frames.length > 0 || this.stills.length > 0 || this.gallery.length > 0) {

            let result = this.postVariant()
            if (!result?.uuid) {
                this.submitted = false
                const message = (result?.errors && Object.values(result.errors).flat()[0]) || 'Upload failed. Please try again.'
                this.uploadFailed(message)
                return
            }
            const variant = result

            const uploader = new S3Upload(variant, this)

            if (this.frames.length > 0) {
                uploader.enqueue(this.method, 1, this.frames)
            }
            if (this.stills.length > 0) {
                uploader.enqueue("stills", 13, this.stills)
            }
            if (this.gallery.length > 0) {
                uploader.enqueue("gallery", 14, this.gallery)
            }

            uploader.upload()
        }
    }
}


function initializeNormalUploaders() {
    // Initialize for normal upload (only if not already initialized)
    let root = document.querySelector('#normal_upload')
    if (root !== null && !root.dataset.uploaderInitialized) {
        const uploader = new NormalUploader(root)
        root.dataset.uploaderInitialized = 'true'
    }

    // Initialize for reupload (only if not already initialized)
    let reuploadRoot = document.querySelector('#normal_reupload')
    if (reuploadRoot !== null && !reuploadRoot.dataset.uploaderInitialized) {
        const uploader = new NormalUploader(reuploadRoot)
        reuploadRoot.dataset.uploaderInitialized = 'true'
    }
}

window.addEventListener('load', initializeNormalUploaders)

// Also initialize when Turbo frames load (for aside content)
document.addEventListener('turbo:frame-load', initializeNormalUploaders)
document.addEventListener('turbo:load', initializeNormalUploaders)
